
import { useState } from "react";
import { supabase } from "./supabaseClient";

export default function Cadastro() {
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [mensagem, setMensagem] = useState("");

  const cadastrar = async (e) => {
    e.preventDefault();
    const { error } = await supabase.auth.signUp({
      email,
      password: senha,
    });

    if (error) {
      setMensagem("Erro: " + error.message);
    } else {
      setMensagem("Verifique seu e-mail para confirmar o cadastro.");
      setEmail("");
      setSenha("");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-yellow-50">
      <form onSubmit={cadastrar} className="bg-white p-6 rounded shadow-md w-full max-w-md">
        <h2 className="text-2xl font-bold mb-4 text-yellow-800">Cadastro</h2>
        <input type="email" placeholder="Email" className="w-full p-2 border mb-3" value={email} onChange={(e) => setEmail(e.target.value)} required />
        <input type="password" placeholder="Senha" className="w-full p-2 border mb-3" value={senha} onChange={(e) => setSenha(e.target.value)} required />
        <button type="submit" className="w-full bg-yellow-500 hover:bg-yellow-600 text-white font-semibold py-2 rounded">Cadastrar</button>
        {mensagem && <p className="mt-4 text-center text-sm text-yellow-700">{mensagem}</p>}
      </form>
    </div>
  );
}
